import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, Tag } from 'lucide-react';

const BlogCard = ({ post }) => {
  // Format date to "dd mmm yyyy" format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('id-ID', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300">
      <Link to={`/blog/${post.slug}`} className="block">
        <div className="h-48 overflow-hidden relative">
          <img 
            src={post.coverImage} 
            alt={post.title} 
            className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
          />
        </div>
      </Link>
      
      <div className="p-6">
        <div className="flex flex-wrap gap-2 mb-3">
          {post.tags && Array.isArray(post.tags) ? post.tags.map((tag, index) => (
            <span key={index} className="inline-flex items-center text-xs font-medium bg-cream/30 text-dark-navy px-2.5 py-0.5 rounded-full">
              <Tag className="w-3 h-3 mr-1" />
              {tag}
            </span>
          )) : (
            <span className="inline-flex items-center text-xs font-medium bg-cream/30 text-dark-navy px-2.5 py-0.5 rounded-full">
              <Tag className="w-3 h-3 mr-1" />
              {post.tags}
            </span>
          )}
        </div>
        
        <Link to={`/blog/${post.slug}`} className="block">
          <h3 className="text-xl font-serif font-bold mb-2 text-gray-900 hover:text-gold transition-colors">
            {post.title}
          </h3>
        </Link>
        
        <p className="text-gray-600 mb-4 line-clamp-3">
          {post.excerpt}
        </p>
        
        <div className="flex items-center text-xs text-gray-500 mt-4">
          <div className="flex items-center mr-4">
            <User className="h-3 w-3 mr-1" />
            <span className="text-xs">{post.author}</span>
          </div>
          <div className="flex items-center">
            <Calendar className="h-3 w-3 mr-1" />
            <span className="text-xs">{formatDate(post.date)}</span>
          </div>
        </div>
        
        <Link 
          to={`/blog/${post.slug}`} 
          className="inline-flex items-center mt-4 text-gold hover:text-cream font-medium"
        >
          Baca Selengkapnya
          <svg
            className="w-4 h-4 ml-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            ></path>
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;